import { render, staticRenderFns } from "./ParticaConfirmDialog.vue?vue&type=template&id=6a3a7a50&"
import script from "./ParticaConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./ParticaConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports